export const sizeTypes = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
};
export const dataHooks = {
  tag: 'variableinput-tag',
  indicator: 'variableinput-indicator',
};
export const inputToTagsSize = {
  tiny: 'tiny',
  small: 'tiny',
  medium: 'small',
  large: 'small',
};
export const entityTypes = {
  variable: 'VARIABLE',
};
export const statusTypes = {
  error: 'error',
  warning: 'warning',
};
